/* Hope's Door pack-for-pack: cap donated packs at the paid pack count.
   Loaded site-wide from layout/theme.liquid (the cart drawer, UpCart, is on
   every page). The donation code takes $15 off EACH donated pack with no
   per-order cap, so without this a shopper could raise the donated quantity
   in the drawer and get extra packs free. Whenever the cart loads or changes,
   donated packs are trimmed to the number of paid laundry-sheet 1-packs
   (removing the paid pack removes its donated pack too), and the shelter code
   is put back if something stripped it (17 Sep).
   Source: ~/jackwork Claude/charity-pdp-mockups/donation-cap.js */
(function(){
  var DONATION_PRODUCT = 10613135769887;   // Donate a Pack of Laundry Sheets (a variant per shelter)
  var DONATION_CODE    = "First donated pack on us! (shelter promo)";
  var lastHealSig = null;
  var PAID_PRODUCT     = 8106639524127;    // Laundry Detergent Sheets
  var busy = false;

  function isPaid(i){ return i.product_id === PAID_PRODUCT && /(^|\/\s*)1 pack$/i.test(String(i.variant_title || '')); }

  function check(){
    if (busy) return;
    busy = true;
    fetch('/cart.js', {headers: {'Accept': 'application/json'}, credentials: 'same-origin'})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(c){
        if (!c || !c.items) return;
        var paid = c.items.filter(isPaid).reduce(function(n, i){ return n + i.quantity; }, 0);
        var lines = c.items.map(function(i, k){ return {i: i, line: k + 1}; })
          .filter(function(x){ return x.i.product_id === DONATION_PRODUCT; });
        var donated = lines.reduce(function(n, x){ return n + x.i.quantity; }, 0);
        /* Removing a code in UpCart sends an empty code set, which also drops
           the shelter code and charges $15 a donated pack. Put it back, once
           per cart state so this can never loop. Skipped while a page's own
           add or code change is in flight. */
        var codes = (c.discount_codes || []).map(function(x){ return x.code; });
        var sig = c.token + '|' + c.items.map(function(i){ return i.key + ':' + i.quantity; }).join(',') + '|' + codes.join(',');
        if (donated > 0 && donated <= paid && codes.indexOf(DONATION_CODE) < 0 && sig !== lastHealSig
            && !window.__pdpxAdding && !window.__pdpxCouponApplying) {
          lastHealSig = sig;
          return fetch('/cart/update.js', {
            method: 'POST', credentials: 'same-origin',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({discount: codes.concat([DONATION_CODE]).join(',')})
          }).then(function(){
            if (typeof window.upcartRefreshCart === 'function') return window.upcartRefreshCart();
          });
        }
        if (donated <= paid) return;
        // keep `paid` units, trimming from the last donation line backwards
        var excess = donated - paid, updates = {};
        for (var k = lines.length - 1; k >= 0 && excess > 0; k--) {
          var cut = Math.min(excess, lines[k].i.quantity);
          updates[lines[k].i.key] = lines[k].i.quantity - cut;
          excess -= cut;
        }
        return fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({updates: updates})
        }).then(function(){
          if (typeof window.upcartRefreshCart === 'function') return window.upcartRefreshCart();
          if (/^\/cart\/?$/.test(location.pathname)) location.reload();
        });
      })
      .catch(function(e){ console.warn('[donation-cap]', e); })
      .then(function(){ busy = false; });
  }

  var hooked = false;
  function hook(){
    if (hooked || typeof window.upcartSubscribeCartUpdated !== 'function') return false;
    hooked = true;
    window.upcartSubscribeCartUpdated(check);
    if (typeof window.upcartSubscribeCartLoaded === 'function') window.upcartSubscribeCartLoaded(check);
    if (typeof window.upcartSubscribeItemRemoved === 'function') window.upcartSubscribeItemRemoved(check);
    return true;
  }
  (function wait(n){ if (!hook() && n < 40) setTimeout(function(){ wait(n + 1); }, 250); })(0);
  check();
})();
